import { useTranslation } from 'react-i18next'
import { getStatusInfo } from '@/utils/submissions'
import { getEntityStatusInfo } from '@/utils/entityStatuses'

interface StatusBadgeProps {
  status: string | null | undefined
  variant?: 'submission' | 'entity' // default 'submission'
}

export function StatusBadge({ status, variant = 'submission' }: StatusBadgeProps) {
  const { t } = useTranslation()

  if (!status) return <span className="text-gray-400">-</span>

  const info = variant === 'entity' ? getEntityStatusInfo(status) : getStatusInfo(status)

  // Translate the status label; fall back to the hardcoded English label from
  // the status map if no translation key is found.
  const translationKey = variant === 'entity'
    ? `entity.status.${status}`
    : `submissions.status.${status}`
  const label = t(translationKey, { defaultValue: info.label })

  return (
    <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full">
      <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: info.color }} />
      <span className="text-gray-600 text-sm">{label}</span>
    </div>
  )
}
